import * as React from 'react';
import { OverreadChallengeStatusEnum, OverreadStatusIdEnum } from '../api/apiTypes';

interface SessionChallengeStatusProps {
    challengeIsClosed: boolean;
    challengeStatus: string;
    analysisOverreadStatus: string;
}

export const SessionChallengeStatus = ({challengeIsClosed, challengeStatus, analysisOverreadStatus}: SessionChallengeStatusProps) => {
    if (!challengeIsClosed && challengeStatus === OverreadChallengeStatusEnum.Challenged && (analysisOverreadStatus === OverreadStatusIdEnum.Accepted || analysisOverreadStatus === OverreadStatusIdEnum.Rejected))
        return <span className="label label-danger">Challenged</span>;

    return null;
}
